/* eslint-disable import/prefer-default-export */
import * as types from '../../../constants/types/express-wifi/ExpressWifiTypes';
import * as load from '../../../constants/types/shared/LoadingTypes';

export const XWFCustomersReducer = (state, action) => {
  const { type, payload } = action;
  switch (type) {
    case load.LOADING_STARTS:
      return {
        ...state,
        isLoading: true,
      };

    case load.LOADING_STOPS:
      return {
        ...state,
        isLoading: false,
      };

    case types.GET_EXPRESSWIFI_CUSTOMERS:
      return {
        ...state,
        customers: payload.customers,
        count: payload.count,
        pages: payload.pages,
        isLoading: false,
      };

    case types.SEARCH_EXPRESSWIFI_CUSTOMERS:
      return {
        ...state,
        customers: payload.customers,
        count: payload.count,
        pages: payload.pages,
        searchCustomersToggle: true,
        isLoading: false,
      };

    default:
      return state;
  }
};
